import { t } from 'shared'

export const copyToClipboard = (value: string) => {
  const tempEl = document.createElement('textarea')
  tempEl.value = value
  document.body.appendChild(tempEl)
  tempEl.select()
  const success = document.execCommand('copy')
  document.body.removeChild(tempEl)

  if (!success) {
    alert(t('misc.copy_paste_unsupported'))
  }

  return success
}
